import { Divider } from "@mui/material";
import React from "react";
import { Container, Content } from "./style";

export default function CardHeader({ Icon, title, children, hideDivider = false, titleStyle, ...props }: any) {
  return (
    <>
      <Container style={props}>
        <Content>
          {Icon}
          <h5 style={{ fontSize: "1.2rem", margin: 0, ...titleStyle }}>{title}:</h5>
        </Content>
        {children}
      </Container>
      {!hideDivider && <Divider style={{ margin: "1rem 0", width: "100%" }} />}
    </>
  );
}
